import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-regular-svg-icons";
import { faStar as faStarFill } from "@fortawesome/free-solid-svg-icons";
import { Button, Spinner } from "reactstrap";

const FileListBox = ({
  className = "",
  documentDetails,
  handleFavUnfavDoc,
  fileStatus,
  selectedIconId,
}) => {

  const [favourite, setFavourite] = useState(false);
  const _handleFavUnfavDoc = (fav, id) => {
    if (!(fileStatus === "true")) {
      handleFavUnfavDoc(fav, id);
      setFavourite(!favourite);
    }
  };
  return (
    <>
      <div className={`file-list-box ${className}`}>
        <div className="head d-flex align-items-start justify-content-between">
          <div className="icon">
            <img
              className="img-fluid"
              src={
                documentDetails?.type_info?.icon
                  ? documentDetails?.type_info?.icon
                  : require(`../../../../assets/img/icons/unlabeled.png`)
              }
              alt="Dollar"
            />
            {/* <img className="img-fluid" src={require('../../../../assets/img/file-home-icon.svg')} alt="Home" />
						<img className="img-fluid" src={require('../../../../assets/img/file-user-icon.svg')} alt="User" /> */}
          </div>
          <div className="txt">
            {/* Bank Statement */}
            {documentDetails?.name?.length > 14
              ? documentDetails?.name?.slice(0, 12) + "..."
              : documentDetails?.name}
          </div>

          <div className="status-icons">
            {documentDetails?.packet_type && <>
              <span
                className={
                  documentDetails?.is_verified === 1
                    ? "d-inline-flex aling-items-center justify-content-center status success-icon"
                    : "d-inline-flex aling-items-center justify-content-center status square-icon error-icon"
                }
              >
                V
              </span>
              <span
                className={
                  documentDetails?.is_correct === 1
                    ? "d-inline-flex aling-items-center justify-content-center status success-icon"
                    : "d-inline-flex aling-items-center justify-content-center status square-icon error-icon"
                }
              >
                C
              </span>
            </>
            }
          </div>
        </div>
        <div className="inner text-center">

          <p>{documentDetails?.types?.name}</p>
          {documentDetails?.packet_type && <>
            {documentDetails?.latest_document_details ? documentDetails?.latest_document_details?.is_correct == 2 ? (
              <p className="status-txt text-danger">Needs Corrected</p>
            ) : (
              <p className="status-txt text-success">Corrected</p>
            ) : documentDetails?.is_correct == 2 ? (
              <p className="status-txt text-danger">Needs Corrected</p>
            ) : (
              <p className="status-txt text-success">Corrected</p>
            )}

            {documentDetails?.latest_document_details ? documentDetails?.latest_document_details?.is_verified == 2 ? (
              <p className="status-txt text-danger">Needs Validated</p>
            ) : (
              <p className="status-txt text-success">
                Validated{" "}
                {documentDetails?.latest_document_details?.validatedAt
                  ? ` : ${(new Date(documentDetails?.latest_document_details?.createdAt).getMonth() + 1)
                    .toString()
                    .padStart(2, "0")}/${new Date(documentDetails?.latest_document_details?.createdAt)
                      .getDate()
                      .toString()
                      .padStart(2, "0")}/${new Date(
                        documentDetails?.latest_document_details?.createdAt
                      ).getFullYear()}`
                  : ""}
              </p>
            )
              : documentDetails?.is_verified == 2 ? (
                <p className="status-txt text-danger">Needs Validated</p>
              ) : (
                <p className="status-txt text-success">
                  Validated{" "}
                  {documentDetails?.validatedAt
                    ? ` : ${(new Date(documentDetails?.createdAt).getMonth() + 1)
                      .toString()
                      .padStart(2, "0")}/${new Date(documentDetails?.createdAt)
                        .getDate()
                        .toString()
                        .padStart(2, "0")}/${new Date(
                          documentDetails?.createdAt
                        ).getFullYear()}`
                    : ""}
                </p>
              )

            }

          </>}



          {!documentDetails?.reviewLabeled && <p>
            Received{" "}
            {`${(new Date(documentDetails?.createdAt).getMonth() + 1)
              .toString()
              .padStart(2, "0")}/${new Date(documentDetails?.createdAt)
                .getDate()
                .toString()
                .padStart(2, "0")}/${new Date(
                  documentDetails?.createdAt
                ).getFullYear()}`}
          </p>}
          {documentDetails?.reviewLabeled && <p>
            Labeled{" "}
            {`${(new Date(documentDetails?.updatedAt).getMonth() + 1)
              .toString()
              .padStart(2, "0")}/${new Date(documentDetails?.updatedAt)
                .getDate()
                .toString()
                .padStart(2, "0")}/${new Date(
                  documentDetails?.updatedAt
                ).getFullYear()}`}
          </p>}
          {
            (documentDetails?.complete ||  documentDetails?.green_v_achieved || documentDetails?.latest_document_details?.complete || documentDetails?.latest_document_details?.green_v_achieved) && <p className="status-txt">
              Completed: Yes
            </p>
          }
        
          {documentDetails?.revisionsId &&
            documentDetails?.revisionsId?.length > 0 && (
              <p>
                Revision{" "}
                {documentDetails?.revisionsId?.length}
              </p>
            )}
          {(documentDetails?.sentToLos || documentDetails?.latest_document_details?.sentToLos) && <p>Sent to LOS : Yes</p>}
          {(documentDetails?.sentToIA || documentDetails?.latest_document_details?.sentToIA) && <p>Sent to Income Analyzer : Yes</p>}
          {(documentDetails?.sentToHalcyon || documentDetails?.latest_document_details?.sentToHalcyon) && <p>Sent To Halcyon/Pre-Authorization : Yes</p>}
          {(documentDetails?.sentToAnalyzer || documentDetails?.latest_document_details?.sentToAnalyzer) && <p>Sent To Analyzer : Yes</p>}

          
        </div>
        <div className="foot d-flex align-items-center justify-content-between">
          <div className="file-size">{documentDetails.size}</div>
          {(documentDetails?.unable_to_validate == true || documentDetails?.latest_document_details?.unable_to_validate == true) && (
            <div className="text-danger">Unable to Validate</div>
          )}
          {/* <Button color="link" className="ml-auto fav-star-btn">
						<FontAwesomeIcon icon={faStar} />
					</Button> */}
          <Button
            color="link"
            className={`fav-star-btn ${documentDetails?.favorite ? "active" : ""
              }`}
          >
            {!(selectedIconId === documentDetails?._id) && (
              <FontAwesomeIcon
                data-toggle="tooltip"
                data-placement="top"
                title={
                  documentDetails?.favorite
                    ? "Click to Mark as NonPriority"
                    : !fileStatus
                      ? "Click to Mark as Priority"
                      : ""
                }
                onClick={() =>
                  _handleFavUnfavDoc(
                    documentDetails?.favorite,
                    documentDetails?._id
                  )
                }
                icon={documentDetails?.favorite ? faStarFill : faStar}
              />
            )}
            {selectedIconId === documentDetails?._id && (
              <span className="load-icon">
                <Spinner color="primary" />
              </span>
            )}
          </Button>
          {/* <Button color="link" className="ml-auto fav-star-btn active">
						<FontAwesomeIcon icon={faStarFill} />
					</Button> */}
        </div>
      </div>
    </>
  );
};
export default FileListBox;
